import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { WorseningComponent } from './components/worsening/worsening/worsening.component';
import { TooltipComponent } from '@angular/material';
//import { SurvivorsComponent } from './components/survivors/survivors/survivors.component';
//import { ClaimComponent } from './components/claim/claim/claim.component';


const routes: Routes = [

  { path: '', component: WorseningComponent, data: { form_title: 'worsening' }},
  { path: 'worsening', component: WorseningComponent, data: { form_title: 'worsening' } },
  { path: 'appeal', component: WorseningComponent, data: { form_title: 'appeal' } },
  { path: 'rediscussion', component: WorseningComponent, data: { form_title: 'rediscussion' } },

  /*{ path: 'survivors', component: SurvivorsComponent },
  { path: 'claim', component: ClaimComponent }*/
];
//RouterModule.forRoot(routes, { useHash: true });
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/app-routing.module.ts